<div class="row">
  <div class="col-sm-12">
    <app-card
      [hidHeader]="true"
      cardClass="institutions-card"
    >
      <!-- ── Cabecera: UGEL + métricas de estado de red ──────────────────── -->
      <div class="inst-toolbar">
        <div class="inst-toolbar__left">
          <div class="inst-select-wrap">
            <i class="feather icon-map-pin inst-select-wrap__icon"></i>
            <select
              id="ugelSelect"
              class="form-select form-select-sm inst-toolbar__ugel-select"
              aria-label="Seleccione una UGEL"
              [ngModel]="groupId"
              (ngModelChange)="onGroupChange($event)"
            >
              <option
                value=""
                disabled
              >
                Seleccione una UGEL...
              </option>
              <ng-container *ngFor="let item of groups">
                <option [value]="item.id">{{ item.name }}</option>
              </ng-container>
            </select>
          </div>
        </div>

        <!-- Métricas de estado de red (solo si hay grupo seleccionado) -->
        <div
          class="inst-toolbar__metrics"
          *ngIf="groupId"
        >
          <!-- Calculando -->
          <ng-container *ngIf="!trafficSummary || trafficSummary.state === 'pending'; else summaryReady">
            <div class="inst-summary__card inst-summary__card--loading">
              <span
                class="spinner-border spinner-border-sm text-secondary me-2"
                role="status"
              ></span>
              <span class="inst-summary__card-label">Calculando estado…</span>
            </div>
          </ng-container>

          <!-- Datos disponibles -->
          <ng-template #summaryReady>
            <div class="inst-metric-group">
              <!-- Total: click limpia el filtro activo -->
              <button
                type="button"
                class="inst-summary__card inst-summary__card--total"
                [class.inst-summary__card--selected]="!selectedStatusFilter"
                (click)="clearStatusFilter()"
                [attr.aria-pressed]="!selectedStatusFilter"
                ngbTooltip="Ver todas las instituciones"
                container="body"
              >
                <span class="inst-summary__card-value">{{ trafficSummary.summary.total }}</span>
                <span class="inst-summary__card-label">Total</span>
              </button>

              <!-- Activas -->
              <button
                type="button"
                class="inst-summary__card inst-summary__card--active"
                [class.inst-summary__card--selected]="selectedStatusFilter === 'active'"
                [disabled]="!trafficSummary.summary.active"
                (click)="onStatusFilterClick('active')"
                [attr.aria-pressed]="selectedStatusFilter === 'active'"
                ngbTooltip="Filtrar por activas"
                container="body"
              >
                <span class="inst-summary__card-value">{{ trafficSummary.summary.active }}</span>
                <span class="inst-summary__card-label">Activas</span>
              </button>

              <!-- Inactivas (incluye unknown) -->
              <button
                type="button"
                class="inst-summary__card inst-summary__card--inactive"
                [class.inst-summary__card--selected]="selectedStatusFilter === 'inactive'"
                [disabled]="!summaryInactiveCount"
                (click)="onStatusFilterClick('inactive')"
                [attr.aria-pressed]="selectedStatusFilter === 'inactive'"
                ngbTooltip="Filtrar por inactivas"
                container="body"
              >
                <span class="inst-summary__card-value">{{ summaryInactiveCount }}</span>
                <span class="inst-summary__card-label">Inactivas</span>
              </button>

              <!-- Refresco manual de resumen global -->
              <button
                type="button"
                class="inst-summary__refresh-btn ms-2"
                (click)="refreshSummary()"
                [disabled]="summaryRefreshing"
                ngbTooltip="Sincronizar estado de red"
                container="body"
                aria-label="Sincronizar estado de red"
              >
                <i
                  class="feather icon-rotate-cw"
                  [class.inst-summary__spin]="summaryRefreshing"
                ></i>
              </button>
            </div>
          </ng-template>
        </div>
      </div>

      <!-- ── Barra de tabla: buscador + chip de filtro activo ───────────── -->
      <div class="inst-table-bar">
        <div class="inst-search">
          <i class="feather icon-search inst-search__icon"></i>
          <input
            type="text"
            class="form-control form-control-sm inst-search__input"
            placeholder="Buscar por nombre o código modular…"
            [ngModel]="searchInput"
            (ngModelChange)="onSearchChange($event)"
          />
          <button
            *ngIf="searchInput"
            type="button"
            class="inst-search__clear"
            aria-label="Limpiar búsqueda"
            (click)="onSearchChange('')"
          >
            <i class="feather icon-x mt-1"></i>
          </button>
        </div>

        <div
          class="inst-filter-chip"
          *ngIf="selectedStatusFilter"
        >
          <i class="feather icon-filter inst-filter-chip__icon"></i>
          <span class="inst-filter-chip__label">{{ summaryFilterLabel | titlecase }}</span>
          <button
            type="button"
            class="inst-filter-chip__clear"
            (click)="clearStatusFilter()"
            aria-label="Limpiar filtro"
          >
            <i class="feather icon-x"></i>
          </button>
        </div>
      </div>

      <!-- ── Tabla ───────────────────────────────────────────────────────── -->
      <div
        class="inst-table-wrap"
        *ngIf="groupId"
      >
        <!-- Overlay de carga -->
        <div
          *ngIf="loading"
          class="inst-loading-overlay"
          aria-live="polite"
          aria-busy="true"
        >
          <span
            class="spinner-border spinner-border-sm text-primary me-2"
            role="status"
            aria-hidden="true"
          ></span>
          <span class="text-muted fw-medium">Actualizando monitoreo…</span>
        </div>

        <div
          class="table-responsive"
          [class.inst-table-wrap__dimmed]="loading"
        >
          <table class="table inst-table">
            <thead>
              <tr>
                <th
                  class="inst-th"
                  style="width: 48px"
                >
                  #
                </th>
                <th
                  class="inst-th text-center"
                  style="width: 110px"
                >
                  Código modular
                </th>
                <th class="inst-th">Nombre de la Institución</th>
                <th class="inst-th">Localidad</th>
                <th
                  class="inst-th text-center"
                  style="width: 130px"
                >
                  Ancho de banda (up/down)
                </th>
                <th
                  class="inst-th text-center"
                  style="width: 120px"
                >
                  Tráfico actual (↑/↓)
                </th>
                <th
                  class="inst-th text-center"
                  style="width: 120px"
                >
                  Estado de red
                </th>
              </tr>
            </thead>

            <tbody *ngIf="institutions.length > 0">
              <tr
                class="inst-row"
                *ngFor="let data of institutions; let i = index; trackBy: trackById"
                [class.inst-row--last-visited]="isLastVisited(data)"
                [attr.id]="rowElementId(data)"
              >
                <td class="inst-td inst-td--num text-muted">
                  {{ (currentPage - 1) * pageSize + i + 1 }}
                </td>
                <td class="inst-td text-center">
                  <a
                    class="inst-code-badge"
                    placement="end"
                    ngbTooltip="Ver detalles de la institución"
                    container="body"
                    (click)="openDetails(modalDetail, data)"
                  >
                    {{ data.name }}
                  </a>
                </td>
                <td class="inst-td fw-semibold text-dark">{{ data.userDetails?.name }}</td>
                <td class="inst-td">
                  <div
                    *ngIf="data.ubigeoDetail"
                    class="inst-location"
                  >
                    <i class="feather icon-map-pin inst-location__icon"></i>
                    <span class="inst-location__text">{{ formatLocality(data) }}</span>
                  </div>
                  <span
                    *ngIf="!data.ubigeoDetail"
                    class="text-muted"
                  >
                    —
                  </span>
                </td>
                <td class="inst-td text-center">
                  <span
                    *ngIf="data.institutionInterface?.service?.plan?.downloadSpeed"
                    class="inst-badge inst-badge--band"
                    ngbTooltip="Velocidad de Plan Contratado"
                    container="body"
                  >
                    {{ data.institutionInterface.service.plan.downloadSpeed }} Mbps
                  </span>
                  <span
                    *ngIf="!data.institutionInterface?.service?.plan?.downloadSpeed"
                    class="text-muted"
                  >
                    —
                  </span>
                </td>

                <!-- Tráfico -->
                <td class="inst-td text-center">
                  <ng-container *ngIf="isTrafficLoading(data)">
                    <span
                      class="spinner-border spinner-border-sm text-secondary"
                      role="status"
                    ></span>
                  </ng-container>
                  <ng-container *ngIf="!isTrafficLoading(data)">
                    <ng-container *ngIf="isTrafficActive(data); else noTraffic">
                      <div class="inst-traffic">
                        <span
                          class="inst-traffic__row inst-traffic__row--up"
                          ngbTooltip="Velocidad actual de subida"
                          container="body"
                        >
                          <i class="feather icon-arrow-up me-1"></i>
                          {{ data.trafficData.tx }}
                        </span>
                        <span
                          class="inst-traffic__row inst-traffic__row--down"
                          ngbTooltip="Velocidad actual de bajada"
                          container="body"
                        >
                          <i class="feather icon-arrow-down me-1"></i>
                          {{ data.trafficData.rx }}
                        </span>
                      </div>
                    </ng-container>
                    <ng-template #noTraffic>
                      <span class="text-muted">—</span>
                    </ng-template>
                  </ng-container>
                </td>

                <!-- Estado -->
                <td class="inst-td text-center">
                  <ng-container *ngIf="isTrafficLoading(data)">
                    <span
                      class="spinner-border spinner-border-sm text-secondary"
                      role="status"
                    ></span>
                  </ng-container>
                  <ng-container *ngIf="!isTrafficLoading(data)">
                    <div class="inst-status">
                      <span
                        class="inst-badge"
                        [ngClass]="isTrafficActive(data) ? 'inst-badge--active' : 'inst-badge--inactive'"
                      >
                        <span
                          class="inst-badge__dot"
                          [ngClass]="isTrafficActive(data) ? 'inst-badge__dot--active' : 'inst-badge__dot--inactive'"
                        ></span>
                        {{ getTrafficStatusLabel(data) }}
                      </span>
                      <span
                        class="inst-status__duration"
                        [ngbTooltip]="getTrafficStatusDurationLabel(data)"
                        container="body"
                      >
                        {{ getTrafficStatusDurationLabel(data) }}
                      </span>
                    </div>
                  </ng-container>
                </td>
              </tr>
            </tbody>

            <tbody *ngIf="!loading && institutions.length === 0">
              <tr>
                <td
                  colspan="7"
                  class="inst-empty"
                >
                  <div class="inst-empty__icon">
                    <i class="feather icon-inbox"></i>
                  </div>
                  <p class="inst-empty__text" *ngIf="statusListNotice === 'pending'">
                    El filtro de estado sigue pendiente. El listado no está disponible hasta que el resumen termine de calcularse.
                  </p>
                  <p class="inst-empty__text" *ngIf="statusListNotice === 'unavailable'">
                    El resumen de estado no está disponible y el filtro no pudo aplicarse.
                  </p>
                  <p class="inst-empty__text" *ngIf="!statusListNotice">
                    <ng-container *ngIf="selectedStatusFilter; else noFilter">
                      No hay instituciones {{ summaryFilterLabel }}.
                    </ng-container>
                    <ng-template #noFilter>No se encontraron instituciones.</ng-template>
                  </p>
                  <p
                    class="inst-empty__hint"
                    *ngIf="!statusListNotice && search"
                  >
                    Intenta con otro término de búsqueda.
                  </p>
                  <button
                    *ngIf="!statusListNotice && selectedStatusFilter && !search"
                    type="button"
                    class="btn btn-sm btn-outline-secondary mt-2"
                    (click)="clearStatusFilter()"
                  >
                    Ver todas las instituciones
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- ── Paginación ──────────────────────────────────────────────────── -->
      <div
        *ngIf="groupId && totalRecords > 0"
        class="inst-pagination"
      >
        <div class="inst-pagination__left">
          <div class="d-flex align-items-center gap-2">
            <span class="inst-pagination__label">Mostrar</span>
            <select
              class="form-select form-select-sm inst-pagination__size-select"
              (change)="onPageSizeChange($event)"
            >
              <option
                value="10"
                [selected]="pageSize == 10"
              >
                10
              </option>
              <option
                value="25"
                [selected]="pageSize == 25"
              >
                25
              </option>
              <option
                value="50"
                [selected]="pageSize == 50"
              >
                50
              </option>
              <option
                value="100"
                [selected]="pageSize == 100"
              >
                100
              </option>
            </select>
          </div>
          <span class="inst-pagination__summary">
            <strong>{{ institutions.length > 0 ? (currentPage - 1) * pageSize + 1 : 0 }}</strong>
            –
            <strong>{{ (currentPage - 1) * pageSize + institutions.length }}</strong>
            de
            <strong class="text-primary">{{ totalRecords }}</strong>
            instituciones
            <ng-container *ngIf="selectedStatusFilter">
              <span class="inst-pagination__filter-tag">({{ summaryFilterLabel }})</span>
            </ng-container>
          </span>
        </div>

        <ngb-pagination
          [collectionSize]="totalRecords"
          [(page)]="currentPage"
          [pageSize]="pageSize"
          (pageChange)="onPageChange($event)"
          [maxSize]="5"
          [rotate]="true"
          [boundaryLinks]="true"
          aria-label="Paginación de instituciones"
          class="mb-0 custom-pagination"
        ></ngb-pagination>
      </div>
    </app-card>
  </div>
</div>

<ng-template
  #modalDetail
  let-c="close"
  let-d="dismiss"
>
  <app-institution-details
    [trafficData]="trafficData"
    [userId]="userId"
    [clientServiceId]="getClientServiceId(institution)"
    (viewHistory)="onViewHistory($event)"
    (closeModal)="onUserClose(c)"
    (dismissModal)="onUserDismiss(d)"
  ></app-institution-details>
</ng-template>
